export const NONE = '';
export const STRIPE = 'stripe';
